import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { dialogActions } from "../components/dialog/slice/dialog-slice";
import { TermsDialogBody } from "../components/dialog/unique/terms-dialog";
import { TermsAgreementManager } from "../manager/terms-agreement-manager";

type UseEnsureTermsAgreement = {
  /**
   * 最新バージョンの利用規約に同意済みであれば、そのまま onAgreed を実行する
   *
   * 未同意の場合は利用規約ダイアログを表示し、同意したタイミングで onAgreed を実行する
   */
  ensureTermsAgreed: (onAgreed: () => void) => void;
};

export const useEnsureTermsAgreement = (): UseEnsureTermsAgreement => {
  const dispatch = useDispatch();

  const openTermsDialog = useCallback((onAgreed: () => void) => {
    dispatch(
      dialogActions.push({
        title: '利用規約',
        element: (
          <TermsDialogBody
            onAgree={() => {
              TermsAgreementManager.agree();
              dispatch(dialogActions.pop());
              onAgreed();
            }}
          />
        ),
      }),
    );
  }, [dispatch]);

  const ensureTermsAgreed = useCallback((onAgreed: () => void): void => {
    if (TermsAgreementManager.hasAgreed()) {
      onAgreed();
      return;
    }
    openTermsDialog(onAgreed);
  }, [openTermsDialog]);

  return {
    ensureTermsAgreed,
  };
};
